var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',[_c('v-card',{staticClass:"mt-8 mx-8 pa-4"},[_c('v-card-title',[_vm._v("تنظیمات کلاس "+_vm._s(_vm.onlineClass.title))])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }